import * as yup from 'yup';
import { VirazhDataField } from './types';

export const validationVirazhSchema = yup.object().shape({
  [VirazhDataField.HOST]: yup.string().required('validate.enter_host'),
  [VirazhDataField.PORT]: yup.string(),
  [VirazhDataField.SIC]: yup.number().min(0, 'min 0').max(255, 'max 255'),
});
